import { useEffect, useState } from 'react';
import { Space, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface Props {
  handleInputValue: Function;
}

const { Search } = Input;

function SearchInput({ handleInputValue }: Props) {
  const [input, setInput] = useState('');

  useEffect(() => {
    handleInputValue(input);
  });
  
  return (
    <Space direction="vertical" className="busk-seacrhSeller">
      <Search
        placeholder="검색"
        suffix={<SearchOutlined />}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
      />
    </Space>
  );
}

export default SearchInput;
